import {
  Controller
} from "@hotwired/stimulus"

import {
  debugLog,
  errorLog
} from '../debug'

debugLog('init edit_profile_controller')
export default class extends Controller {
  // static targets = ["name"]
  // static outlets = ['dependent-field']

  connect() {
    // debugLog(this.element)
    this.tryEnableDependentFields()
  }

  update(event) {
    debugLog("edit_profile_controller update")
    this.tryEnableDependentFields()
  }

  tryEnableDependentFields() {
    for (let dep_field of this.element.getElementsByClassName('dependent-field')) {
      const is_container = dep_field.classList.contains('container')
      const is_min_max = dep_field.classList.contains('min-max')
      const dep_field_wrapper = this.element.querySelector(`#${dep_field.id}--wrapper`)
      let dependencies = {}
      try {
        dependencies = JSON.parse(dep_field.dataset.formFieldDependentValue)
      } catch (error) {
        errorLog(
          error.message,
          'dependencies: ',
          dep_field.dataset.formFieldDependentValue,
          'field: ',
          dep_field);
      }
      const dependency_type = dep_field.dataset.dependencyType
      let deps_open = dependency_type == 'OR' ? 1 : dependencies.length

      if (is_min_max)
        var dep_field_min_max_wrapper = this.element.querySelector(`#${dep_field.id.substring(0, dep_field.id.length - 5)}--min-max--wrapper`)

      debugLog('dep_field id:', dep_field.id)
      debugLog('dep_field_wrapper', dep_field_wrapper)
      debugLog('dep_field_min_max_wrapper', dep_field_min_max_wrapper)
      debugLog('dependencies', dependencies)
      debugLog('dependency type', dependency_type)

      dependencies.forEach((dep) => {
        debugLog("depp", dep)
        let elm = null
        let fill_value = null
        if (dep.includes('//option-')) {
          let dep_splitted = dep.split('//option-')
          let select_field = dep_splitted[0]
          fill_value = dep_splitted[1]
          elm = this.element.querySelector(`#${select_field}`)
        } else {
          elm = this.element.querySelector(`#${dep}`)
        }

        const field_type = elm.dataset.fieldType
        debugLog("dep solved?", this.interpreteFieldValueFilled(field_type, elm, fill_value))
        if (this.interpreteFieldValueFilled(field_type, elm, fill_value)) {
          deps_open--
        }
      })

      if (deps_open <= 0) {
        debugLog('deps solved for', dep_field.name)
        if (is_container) {
          dep_field.style.display = 'block'
        } else if (dep_field_min_max_wrapper) {
          dep_field_min_max_wrapper.hidden = false
          dep_field_wrapper.hidden = false
          dep_field.disabled = false
          debugLog("dep_field_min_max_wrapper shown?", dep_field_min_max_wrapper.id)

        } else {
          dep_field_wrapper.hidden = false
          dep_field.disabled = false
          debugLog("No dep_field_min_max_wrapper shown")
        }
      } else {
        if (is_container) {
          dep_field.style.display = 'none'
        } else if (dep_field_min_max_wrapper) {
          dep_field.disabled = true
          dep_field_wrapper.hidden = true
          dep_field_min_max_wrapper.hidden = true
          debugLog("dep_field_min_max_wrapper HIDDEN")

        } else {
          dep_field.disabled = true
          dep_field_wrapper.hidden = true
          debugLog("No dep_field_min_max_wrapper hidden")
        }
      }
    }
  }

  interpreteFieldValueFilled(field_type, element, fill_value = null) {
    switch (field_type) {
      case 'select':
        return element.options[element.selectedIndex].value == fill_value
        break
      case 'checkbox':
        return element.checked
        break
      case 'number':
        return (element.value != undefined && element.value > 0)
        break
      case 'text':
        return (element.value != undefined && element.value != '')
        break
      default:
        debugLog(`unknown field type: ${field_type}.`);
    }
  }
}